export default {
  'pages.ledger.adminTitle': 'Ledger Management',
  'pages.ledger.consoleTitle': 'My Ledger',
  'pages.ledger.adminDesc': 'View and manage all users\' ledger records, filter by user / type / category / time.',
  'pages.ledger.consoleDesc': 'Manage ledger records owned by the current account.',
  'pages.ledger.new': 'Add Record',
  'pages.ledger.colUser': 'Owner',
  'pages.ledger.colUserIdFilter': 'User ID',
  'pages.ledger.userIdPlaceholder': 'Filter by user ID',
  'pages.ledger.colType': 'Type',
  'pages.ledger.colAmount': 'Amount',
  'pages.ledger.colCategory': 'Category',
  'pages.ledger.colOccurredAt': 'Occurred At',
  'pages.ledger.colRemark': 'Remark',
  'pages.ledger.colCreatedAt': 'Created At',
  'pages.ledger.colTimeRange': 'Occurred At',
  'pages.ledger.colActions': 'Actions',
  'pages.ledger.edit': 'Edit',
  'pages.ledger.delete': 'Delete',
  'pages.ledger.confirmDelete': 'Delete this record?',
  'pages.ledger.confirm': 'OK',
  'pages.ledger.cancel': 'Cancel',
  'pages.ledger.created': 'Record added',
  'pages.ledger.updated': 'Record updated',
  'pages.ledger.deleted': 'Record deleted',
  'pages.ledger.opFail': 'Operation failed',
  'pages.ledger.typeRequired': 'Please select a type',
  'pages.ledger.amountRequired': 'Please enter an amount',
  'pages.ledger.amountMin': 'Amount must be greater than 0',
  'pages.ledger.categoryRequired': 'Please select or enter a category',
  'pages.ledger.categoryPlaceholder': 'Select or enter a category',
  'pages.ledger.occurredRequired': 'Please select a time',
  'pages.ledger.remarkPlaceholder': 'Remark (optional)',
  'pages.ledger.targetUser': 'Owner',
  'pages.ledger.targetUserTip': 'Leave blank to assign to the current account',
  'pages.ledger.searchUserPlaceholder': 'Search user by name',
  'pages.ledger.noUserFound': 'No user found',
  'pages.ledger.summaryTitle': 'Monthly Summary',
  'pages.ledger.summaryIncome': 'Income',
  'pages.ledger.summaryExpense': 'Expense',
  'pages.ledger.summaryBalance': 'Balance',
  'pages.ledger.summaryMonth': 'Month',
  'pages.ledger.summaryCatType': 'Type',
  'pages.ledger.summaryCatName': 'Category',
  'pages.ledger.summaryCatCount': 'Count',
  'pages.ledger.summaryCatTotal': 'Subtotal',
  'pages.ledger.currencyLabel': 'Ledger Currency',
  'pages.ledger.currencySetFirst': 'Set Ledger Currency',
  'pages.ledger.currencyChange': 'Change Ledger Currency',
  'pages.ledger.currencyChangeTip': 'After changing, historical records keep their original currency; list and summary only count the new currency. Continue?',
  'pages.ledger.currencySetFirstTip': 'Set a currency before your first record. Choose the currency you use daily:',
  'pages.ledger.currencyRequired': 'Please select a currency',
  'pages.ledger.currencySelectPlaceholder': 'Select currency',
  'pages.ledger.currencySet': 'Currency set',
  'pages.ledger.type.expense': 'Expense',
  'pages.ledger.type.income': 'Income',
};
